import { login, getInfo, logout } from '@/api/login'
import { getToken, setToken, removeToken, setUser } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    user: {},
    roles: [],
    // 第一次加载菜单时用到
    loadMenus: false
  },

  mutations: {
    SET_TOKEN: (state, token) => {

      state.token = token
    },
    SET_USER: (state, user) => {
      setUser(user.nickName)
      state.user = user
    },
    SET_ROLES: (state, roles) => {

      localStorage.setItem('roles', JSON.stringify(roles))
      state.roles = roles
    },
    SET_LOAD_MENUS: (state, loadMenus) => {
      state.loadMenus = loadMenus
    }
  },

  actions: {

    // 登录
    Login({ commit }, userInfo) {
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        login(userInfo.username, userInfo.password, userInfo.code, userInfo.uuid).then(res => {

          const mapCenter = {

            '衢江大队': [28.979947, 118.959070],
            '柯城大队': [28.965974, 118.876871],
            '江山大队': [28.745333, 118.635198],
            '常山大队': [28.901028, 118.521267],
            '开化大队': [29.131894, 118.402325],
            '龙游大队': [29.031999, 119.174192]
          }
          const divisions = {
            '衢江大队': '330803',
            '柯城大队': '330802',
            '江山大队': '330881',
            '常山大队': '330822',
            '开化大队': '330824',
            '龙游大队': '330825'
          }

          divisions[res.authDept] = divisions[res.authDept] ? divisions[res.authDept] : '330802'

          mapCenter[res.authDept] = mapCenter[res.authDept] ? mapCenter[res.authDept] : [28.980252, 118.849064]


          localStorage.setItem('mapCenter', JSON.stringify(mapCenter[res.authDept]))


          localStorage.setItem('divisions', divisions[res.authDept])
          localStorage.setItem('user', JSON.stringify(res.user))
          

          setToken(res.token, rememberMe)
          commit('SET_TOKEN', res.token)
          setUserInfo(res.user, commit)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          commit('SET_LOAD_MENUS', true)
          resolve()
        }).catch(error => {


          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          setUserInfo(res, commit)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          logOut(commit)
          resolve()
        }).catch(error => {
          logOut(commit)
          reject(error)
        })
      })
    },

    updateLoadMenus({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_MENUS', false)
      })
    }
  }
}

export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('SET_ROLES', [])
  removeToken()
}

export const setUserInfo = (res, commit) => {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.roles.length === 0) {
    commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
  } else {
    commit('SET_ROLES', res.roles)
  }
  commit('SET_USER', res)
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js